import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import DynamicForm from '../../../common/forms/DynamicForm';
import { generateCabinCrewAssignmentColumns } from '../../../../config/dynamicFormFields';
import RegisteredBusSelect from '../../../common/forms/select/RegisteredBusSelect';
import Alert from '../../../common/informative/Alert';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import FormFooter from '../../../common/forms/FormFooter';
import {
  clearCabinCrewBusAssignments,
  getCabinCrewBusAssignments,
  putCabinCrewBusUnassign,
  setInitialValues,
} from '../../../../actions/traffic/CabinCrewBusAssignment';

const selector = formValueSelector('CabinCrewBusAssignmentForm');

export class CabinCrewBusAssignmentForm extends Component {
  state = {
    disabledBus: false,
    showModal: false,
    modalBody: '',
    formValues: null,
    index: null,
    fields: null,
  };

  componentDidMount() {
    this.onMount();
  }

  componentDidUpdate() {
    this.setCabinCrewBusAssignmentInitialValues();
  }

  componentWillUnmount() {
    const { dispatchSetInitialValues, dispatchClearCabinCrewBusAssignments } =
      this.props;
    dispatchSetInitialValues({});
    dispatchClearCabinCrewBusAssignments();
  }

  onMount = () => {
    const {
      dispatchSetInitialValues,
      dispatchGetCabinCrewBusAssignments,
      bus,
    } = this.props;
    this.setState({ disabledBus: !!bus.value });
    if (bus.value) {
      dispatchSetInitialValues({ bus });
      dispatchGetCabinCrewBusAssignments({
        query: `companyBusId:${bus.label}`,
      });
    }
  };

  onHandleSubmit = (formValues) => {
    const {
      initialValues: { assignmentIds },
    } = this.props;
    if (this.validateCabinCrewList(formValues.cabinCrewList)) {
      if (formValues.cabinCrewList.length === assignmentIds.length) {
        toastr.error('Error', 'Debe agregar un nuevo tripulante.');
      } else {
        this.setState({
          showModal: true,
          modalBody: `¿Está seguro que quiere asignar el tripulante ${
            formValues.cabinCrewList[formValues.cabinCrewList.length - 1]
              .cabinCrew.label
          } al bus ${formValues.bus.label}?`,
          formValues,
          index: null,
          fields: null,
        });
      }
    }
  };

  onClickAdd = (fields) => {
    const {
      cabinCrewList,
      initialValues: { assignmentIds },
    } = this.props;

    if (
      cabinCrewList.length === 0 ||
      this.validateCabinCrewList(cabinCrewList)
    ) {
      if (cabinCrewList.length !== assignmentIds.length)
        toastr.error(
          'Error',
          'Antes de agregar un tripulante debe registrarlo.',
        );
      else fields.push({});
    }
  };

  onClickRemove = (index, fields) => {
    if (this.props.initialValues.assignmentIds[index]) {
      const {
        cabinCrewList,
        initialValues: { bus },
      } = this.props;
      this.setState({
        showModal: true,
        modalBody: `¿Está seguro que quiere quitar el tripulante ${cabinCrewList[index].cabinCrew.label} del bus ${bus.label}?`,
        index,
        fields,
        formValues: null,
      });
    } else {
      fields.remove(index);
    }
  };

  onRegisteredBusChange = (bus) => {
    const {
      dispatchGetCabinCrewBusAssignments,
      dispatchClearCabinCrewBusAssignments,
      dispatchSetInitialValues,
    } = this.props;
    dispatchClearCabinCrewBusAssignments();
    dispatchSetInitialValues(
      bus.value ? { bus: { value: bus.value, label: bus.label } } : {},
    );
    if (bus.value) {
      dispatchGetCabinCrewBusAssignments({
        query: `companyBusId:${bus.label}`,
      });
    }
  };

  onModalDoneClick = () => {
    const { index, fields, formValues } = this.state;
    if (fields) {
      const { initialValues, dispatchPutCabinCrewBusUnassign } = this.props;
      if (initialValues.assignmentIds[index]) {
        dispatchPutCabinCrewBusUnassign({
          cabinCrewBusAssignmentId: initialValues.assignmentIds[index],
          companyBusId: initialValues.bus.label,
        });
      }
      fields.remove(index);
    } else if (formValues) {
      this.props.onSubmit(formValues);
    }
    this.onModalCancelClick();
  };

  onModalCancelClick = () => {
    this.setState({
      showModal: false,
      modalBody: '',
      index: null,
      fields: null,
      formValues: null,
    });
  };

  setCabinCrewBusAssignmentInitialValues = () => {
    const {
      assignmentsContent,
      dispatchSetInitialValues,
      initialValues: { bus },
    } = this.props;

    const cabinCrewList = [];
    const assignmentIds = [];

    assignmentsContent.forEach(({ id, cabinCrewAssignmentDateList }) => {
      const { cabinCrew, cabinCrewId } = cabinCrewAssignmentDateList[0];

      assignmentIds.push(id);
      cabinCrewList.push({
        cabinCrew: { value: cabinCrewId, label: cabinCrew.customer.fullName },
      });
    });

    dispatchSetInitialValues({
      bus,
      assignmentIds,
      cabinCrewList,
    });
  };

  validateCabinCrewList = (rowValues) => {
    let isValid = true;
    if (rowValues.length) {
      const isInvalidData = rowValues.some((row) => {
        if (!(row.cabinCrew && row.cabinCrew.value)) {
          toastr.error('Error', 'Seleccione un tripulante.');
          return true;
        }
        return false;
      });
      isValid = !isInvalidData;
    } else {
      toastr.error('Error', 'Ingrese almenos un tripulante.');
      isValid = false;
    }
    return isValid;
  };

  renderDynamicForm = () => {
    const {
      initialValues: { bus },
    } = this.props;
    if (!bus) {
      return <Alert message="Seleccione un bus." />;
    }
    return (
      <DynamicForm
        name="cabinCrewList"
        columns={generateCabinCrewAssignmentColumns()}
        onClickRemove={this.onClickRemove}
        onClickAdd={this.onClickAdd}
      />
    );
  };

  render() {
    const { handleSubmit, loading } = this.props;
    const { showModal, modalBody } = this.state;
    if (loading) {
      return <Loader />;
    }
    return (
      <Fragment>
        <ConfirmationModal
          show={showModal}
          body={modalBody}
          onClickConfirm={this.onModalDoneClick}
          onClickCancel={this.onModalCancelClick}
        />
        <Form onSubmit={handleSubmit(this.onHandleSubmit)}>
          <FormGroup row>
            <FormItem label="Bus" required>
              <Field
                name="bus"
                component={RegisteredBusSelect}
                onChange={this.onRegisteredBusChange}
                validate={[isRequired]}
                isDisabled={this.state.disabledBus}
                onlyActive
              />
            </FormItem>
          </FormGroup>
          <h5>Lista de Tripulantes</h5>
          {this.renderDynamicForm()}
          <FormFooter />
        </Form>
      </Fragment>
    );
  }
}

CabinCrewBusAssignmentForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cabinCrewList: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line react/forbid-prop-types
  assignmentsContent: PropTypes.arrayOf(PropTypes.object),
  bus: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  dispatchGetCabinCrewBusAssignments: PropTypes.func.isRequired,
  dispatchClearCabinCrewBusAssignments: PropTypes.func.isRequired,
  dispatchSetInitialValues: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    cabinCrewList: PropTypes.arrayOf(
      PropTypes.shape({
        cabinCrew: PropTypes.shape({
          value: PropTypes.number,
          label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }),
      }),
    ),
    bus: PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    assignmentIds: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ),
  }),
  dispatchPutCabinCrewBusUnassign: PropTypes.func.isRequired,
};

CabinCrewBusAssignmentForm.defaultProps = {
  loading: false,
  cabinCrewList: [],
  initialValues: { cabinCrewList: [], bus: {}, assignmentIds: [] },
  assignmentsContent: [],
  bus: {},
};

const mapStateToProps = (state) => ({
  loading: !state.TrafficUnit.CabinCrewBusAssignment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
  assignmentsContent: state.TrafficUnit.CabinCrewBusAssignment.getIn([
    'all',
    'content',
  ]).get('content'),
  cabinCrewList: selector(state, 'cabinCrewList'),
  initialValues: state.TrafficUnit.CabinCrewBusAssignment.getIn([
    'initialValues',
  ]),
});

const mapDispatchToProps = {
  dispatchSetInitialValues: setInitialValues,
  dispatchGetCabinCrewBusAssignments: getCabinCrewBusAssignments,
  dispatchClearCabinCrewBusAssignments: clearCabinCrewBusAssignments,
  dispatchPutCabinCrewBusUnassign: putCabinCrewBusUnassign,
};

const formComponent = reduxForm({
  form: 'CabinCrewBusAssignmentForm',
  enableReinitialize: true,
})(CabinCrewBusAssignmentForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
